var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "featured-categories", style: _vm.paddingStyles },
      [
        _c(
          "div",
          { staticClass: "featured-categories__header-container" },
          [
            _vm.featuredCategories.preHeading
              ? _c(
                  "h4",
                  {
                    staticClass: "preheader featured-categories__preheading",
                    class: _vm.featuredCategories.textColor
                  },
                  [_vm._v(_vm._s(_vm.featuredCategories.preHeading))]
                )
              : _vm._e(),
            _vm.featuredCategories.heading
              ? _c(
                  "h2",
                  {
                    staticClass: "h3 featured-categories__heading",
                    class: _vm.featuredCategories.headingColor
                  },
                  [_vm._v(_vm._s(_vm.featuredCategories.heading))]
                )
              : _vm._e(),
            _vm.featuredCategories.subHeading
              ? _c(
                  "h3",
                  {
                    staticClass: "subheader featured-categories__subheading",
                    class: _vm.featuredCategories.textColor
                  },
                  [_vm._v(_vm._s(_vm.featuredCategories.subHeading))]
                )
              : _vm._e(),
            _vm.$mq !== "mobile"
              ? _c("div", { staticClass: "controls-container" }, [
                  _c("div", { staticClass: "arrows" }, [
                    _c(
                      "div",
                      {
                        staticClass: "arrow arrow-prev",
                        on: { click: _vm.slidePrev }
                      },
                      [
                        _c("icon", {
                          attrs: {
                            "fill-class": _vm.featuredCategories.arrowColor,
                            name: "chevron-left",
                            size: "14px"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "arrow arrow-next",
                        on: { click: _vm.slideNext }
                      },
                      [
                        _c("icon", {
                          attrs: {
                            "fill-class": _vm.featuredCategories.arrowColor,
                            name: "chevron-right",
                            size: "14px"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.featuredCategories.enableCta && _vm.$mq !== "mobile"
              ? _c(
                  "v-button",
                  {
                    staticClass: "featured-categories__view-all-button",
                    class: _vm.featuredCategories.ctaLayout,
                    attrs: { href: "/blogs/all", tag: "a" }
                  },
                  [_vm._v("View All")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm.$mq !== "mobile"
          ? _c(
              "swiper",
              {
                ref: "blogSectionCategoryDesktop",
                staticClass: "featured-categories__categories",
                attrs: { options: _vm.desktopOptions }
              },
              _vm._l(_vm.featuredCategories.categories, function(
                category,
                index
              ) {
                return _c("swiper-slide", { key: index }, [
                  _c(
                    "a",
                    {
                      key: index,
                      staticClass:
                        "featured-categories__category clip-transition",
                      class: _vm.featuredCategories.textColor,
                      attrs: { href: category.categoryUrl }
                    },
                    [
                      _c("div", {
                        staticClass: "featured-categories__image",
                        style: {
                          backgroundImage: "url('" + category.featuredImg + "')"
                        },
                        attrs: { "data-clip-img": "" }
                      }),
                      _c(
                        "h5",
                        { staticClass: "h5 featured-categories__title" },
                        [_vm._v(_vm._s(category.categoryName))]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "body-sm-mobile body-md-tablet-up featured-categories__description"
                        },
                        [_vm._v(_vm._s(category.categoryDescription))]
                      ),
                      _c(
                        "v-link",
                        {
                          staticClass:
                            "featured-articles__read-more link link--primary"
                        },
                        [_vm._v("Read More")]
                      )
                    ],
                    1
                  )
                ])
              }),
              1
            )
          : _vm._e(),
        _c(
          "swiper",
          {
            ref: "blogSectionCategoryMobile",
            staticClass: "featured-categories__categories--mobile",
            attrs: { options: _vm.mobileOptions }
          },
          _vm._l(_vm.featuredCategories.categories, function(category, index) {
            return _c("swiper-slide", { key: index }, [
              _c(
                "a",
                {
                  staticClass: "featured-categories__category clip-transition",
                  class: _vm.featuredCategories.textColor,
                  attrs: { href: category.categoryUrl }
                },
                [
                  _c("div", {
                    staticClass: "featured-categories__image",
                    style: {
                      backgroundImage: "url('" + category.featuredImg + "')"
                    },
                    attrs: { "data-clip-img": "" }
                  }),
                  _c("h5", { staticClass: "h5 featured-categories__title" }, [
                    _vm._v(_vm._s(category.categoryName))
                  ]),
                  _c(
                    "p",
                    {
                      staticClass:
                        "body-sm-mobile body-md-tablet-up featured-categories__description"
                    },
                    [_vm._v(_vm._s(category.categoryDescription))]
                  ),
                  _c(
                    "v-link",
                    {
                      staticClass:
                        "featured-articles__read-more link link--primary"
                    },
                    [_vm._v("Read More")]
                  )
                ],
                1
              )
            ])
          }),
          1
        ),
        _vm.$mq === "mobile"
          ? _c("div", { staticClass: "controls-container" }, [
              _c(
                "div",
                { staticClass: "pagination-dots" },
                _vm._l(_vm.featuredCategories.categories, function(
                  category,
                  index
                ) {
                  return _c("div", {
                    key: "dot-" + index,
                    staticClass: "dot",
                    class: [_vm.dotActive(index), "dot-" + index],
                    on: {
                      click: function($event) {
                        return _vm.slidePagination(index)
                      }
                    }
                  })
                }),
                0
              )
            ])
          : _vm._e(),
        _vm.featuredCategories.enableCta && _vm.$mq === "mobile"
          ? _c(
              "v-button",
              {
                staticClass: "featured-categories__view-all-button",
                class: _vm.featuredCategories.ctaLayout,
                attrs: { href: "/blogs/all", tag: "a" }
              },
              [_vm._v("View All")]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }